import HttpClient from '../../../core/HttpClient';
import Failure from '../../../core/Failure';
import { ISubscriptionItem } from '../../../presentation/contexts/data/companies/CompanyEditionFormContext';

type GetCompanySubscriptionsPageOptions = {
  page: number;
  pageSize: number;
  search: string;
  type: string;
};

async function getCompanySubscriptionsPage(
  companyId: string,
  options: GetCompanySubscriptionsPageOptions
): Promise<{ subscriptions: ISubscriptionItem[]; totalCount: number }> {
  try {
    const params = new URLSearchParams({
      page: String(options.page),
      pageSize: String(options.pageSize),
      search: options.search,
      type: options.type,
    });
    const response = await HttpClient.get(
      `/backoffice/companies/${companyId}/subscriptions?${params.toString()}`
    );
    return {
      subscriptions: (response?.data?.subscriptions ?? []) as ISubscriptionItem[],
      totalCount: (response?.data?.totalCount ?? 0) as number,
    };
  } catch (e) {
    throw new GetCompanySubscriptionsPageFailure((e as Error).message);
  }
}

export class GetCompanySubscriptionsPageFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getCompanySubscriptionsPage;
